import styled from "styled-components";

export const SwitchLeftLabel = styled.label`
	z-index: 2;
	& .inactive {
		z-index: 1;
	}
`;
